import { Route, Routes } from 'react-router-dom';

import HistoryLayout from '../components/history/HistoryLayout.jsx';
import SubtabIndexRedirect from '../components/SubtabIndexRedirect.jsx';
import { DEFAULT_HISTORY_SUBTAB } from '../constants/history.js';
import ActivityTabPage from './ActivityTabPage.jsx';
import HistoryNotesPage from './HistoryNotesPage.jsx';

/**
 * History (CT-5724): the Activity tab of CT-5527 renamed — by the tabs payload,
 * the kind stays ACTIVITY — with two subtabs as child routes: Timeline (the feed)
 * and From notes. The shared toolbar and forms live in `HistoryLayout`.
 *
 * @param {object} props
 * @param {{ id: string }} props.tab
 */
function HistoryTabPage({ tab }) {
  return (
    <Routes>
      <Route element={<HistoryLayout />}>
        <Route index element={<SubtabIndexRedirect to={DEFAULT_HISTORY_SUBTAB} />} />
        <Route path="timeline" element={<ActivityTabPage tab={tab} />} />
        <Route path="notes" element={<HistoryNotesPage />} />
      </Route>
    </Routes>
  );
}

export default HistoryTabPage;
